import React, { useRef, useEffect } from "react";
import "../styles/HomeAboutVideo.css";

const base = `${process.env.PUBLIC_URL || ""}/assets/videos/video1`;
const videoSrcMp4 = `${base}.mp4`;
const videoSrcMov = `${base}.mov`;

export default function HomeAboutVideo() {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return undefined;
    const tryPlay = () => {
      v.play().catch(() => {});
    };
    v.addEventListener("loadeddata", tryPlay);
    v.addEventListener("canplay", tryPlay);
    tryPlay();
    return () => {
      v.removeEventListener("loadeddata", tryPlay);
      v.removeEventListener("canplay", tryPlay);
    };
  }, []);

  return (
    <section className="home-about-video" aria-label="Background video">
      <video
        ref={videoRef}
        className="home-about-video__media"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src={videoSrcMp4} type="video/mp4" />
        <source src={videoSrcMov} type="video/quicktime" />
      </video>
      <div className="home-about-video__fade" aria-hidden="true" />
    </section>
  );
}
